import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { 
  XMarkIcon,
  HomeIcon,
  TruckIcon,
  UserGroupIcon,
  Cog6ToothIcon,
  ArrowRightOnRectangleIcon
} from '@heroicons/react/24/outline';

function AdminNavModal({ isOpen, onClose }) {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/admin/login');
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  };

  const menuItems = [
    { icon: <HomeIcon className="w-6 h-6" />, label: 'Dashboard', path: '/admin/dashboard' },
    { icon: <TruckIcon className="w-6 h-6" />, label: 'Shipments', path: '/admin/shipments' },
    { icon: <UserGroupIcon className="w-6 h-6" />, label: 'Users', path: '/admin/users' },
    { icon: <Cog6ToothIcon className="w-6 h-6" />, label: 'Settings', path: '/admin/settings' },
  ];

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4">
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose}></div>
        
        <div className="relative bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 rounded-2xl w-full max-w-sm p-6 border border-white/10 shadow-xl">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-xl font-bold text-white">Admin Menu</h2>
            <button
              onClick={onClose}
              className="text-white/60 hover:text-white transition-colors"
            >
              <XMarkIcon className="w-6 h-6" />
            </button>
          </div>

          <nav className="space-y-2">
            {menuItems.map((item) => (
              <button
                key={item.path}
                onClick={() => {
                  navigate(item.path);
                  onClose();
                }}
                className="w-full flex items-center gap-3 px-4 py-3 text-white/80 hover:text-white hover:bg-white/5 rounded-xl transition-all"
              >
                {item.icon}
                <span>{item.label}</span>
              </button>
            ))}

            <div className="border-t border-white/10 my-4"></div>

            <button
              onClick={handleLogout}
              className="w-full flex items-center gap-3 px-4 py-3 text-red-400 hover:text-red-300 hover:bg-red-500/10 rounded-xl transition-all"
            >
              <ArrowRightOnRectangleIcon className="w-6 h-6" />
              <span>Logout</span>
            </button>
          </nav>
        </div>
      </div>
    </div>
  );
}

export default AdminNavModal; 